export const UPDATE_COURSES = "UPDATE_COURSES";
export const ADD_COURSE = "ADD_COURSE";
export const DELETE_COURSE = "DELETE_COURSE";
export const UPDATE_COURSE = "UPDATE_COURSE";
export const UPDATE_LECTURE = "UPDATE_LECTURE";
export const ADD_LECTURE = "ADD_LECTURE";
export const SELECT_LECTURE = "SELECT_LECTURE";
export const DELETE_LECTURE = "DELETE_LECTURE";
export const TEACHER_FETCH_START = "TEACHER_FETCH_START";
export const TEACHER_FETCH_SUCCESS = "TEACHER_FETCH_SUCCESS";
export const TEACHER_FETCH_FAILURE = "TEACHER_FETCH_FAILURE";
export const RESET_ERROR = "RESET_ERROR";

const TeacherReducer = (state, action) => {
  switch (action.type) {
    case TEACHER_FETCH_START: {
      return { ...state, loading: true };
    }
    case TEACHER_FETCH_FAILURE: {
      return { ...state, error: action.payload, loading: false };
    }
    case TEACHER_FETCH_SUCCESS: {
      return { ...state, loading: false, error: null };
    }
    case UPDATE_COURSES: {
      // convert the array of courses to an object with UUIDs as keys
      const map = new Map(action.payload.map((c) => [c.uuid, c]));

      let courses = Object.fromEntries(map);
      courses = state.courses ? Object.assign(courses, state.courses) : courses;

      return { ...state, courses, loading: false, error: null };
    }
    case ADD_COURSE:
    case UPDATE_COURSE: {
      const { uuid, lectures } = action.payload;

      // convert the array of courses to an object with UUIDs as keys
      const map = new Map(lectures?.map((l) => [l.uuid, l]));
      return {
        ...state,
        loading: false,
        error: null,
        courses: {
          ...state.courses,
          [uuid]: {
            ...action.payload,
            lectures: Object.fromEntries(map),
          },
        },
      };
    }
    case DELETE_COURSE: {
      const uuid = action.payload;

      delete state.courses[uuid];

      return { ...state, loading: false, error: null };
    }
    case ADD_LECTURE:
    case UPDATE_LECTURE: {
      const {
        courseUUID,
        lecture: { uuid },
      } = action.payload;

      delete state.courses[courseUUID].lectures[uuid];

      return { ...state, loading: false, error: null };
    }
    case SELECT_LECTURE: {
      return { ...state, currentLecture: action.payload, loading: false, error: null };
    }
    case DELETE_LECTURE: {
      const lectureUUID = action.payload;
      const course = Object.entries(state.courses).find(([uuid, course]) => lectureUUID in course.lectures)[0];

      return {
        ...state,
        loading: false,
        error: null,
        courses: {
          ...state.courses,
          [course]: {
            ...state.courses[course],
            lectures: {
              ...state.courses[course].lectures,
              [lectureUUID]: undefined,
            },
          },
        },
      };
    }
    case RESET_ERROR: {
      return { ...state, error: null };
    }

    default:
      return state;
  }
};

export default TeacherReducer;
